import React, { useState, useEffect, useRef } from "react";
import "./Auth.css";
import TextInput from "../components/TextInput";
import axios from "axios";
import openNotification from "../components/OpenNotification";
import FailedLogin from "./FailedLogin";
import { useNavigate } from "react-router-dom";


const Login = () => {
  const navigate = useNavigate();
  const countdownRef = useRef(null);
  // const currentYear = new Date().getFullYear();

  const storedData = JSON.parse(localStorage.getItem("loginData")) || {};
  const initialDeadline = storedData.deadline || Date.now() + 1000 * 60 * 5;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("This is a required field");
  const [showFailedLogin, setShowFailedLogin] = useState(storedData.showFailedLogin || false);
  const [failedLoginAttempts, setFailedLoginAttempts] = useState(storedData.failedLoginAttempts || 0);
  const [deadline, setDeadline] = useState(initialDeadline);

  const [ipAddress, setIpAddress] = useState("");
  const [browser, setBrowser] = useState("");


  const getIpAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error getting IP address:', error);
      return null;
    }
  };
  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown Browser";
  
    if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
    } else if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
    } else if (userAgent.indexOf("Edge") > -1) {
      browserName = "Edge";
    } else if (userAgent.indexOf("MSIE") > -1) {
      browserName = "Internet Explorer";
    }
  
    return browserName;
  };


  useEffect(() => {
    document.title = "Admin Login | BarterFunds";

    const fetchUserData = async () => {
    setIpAddress(await getIpAddress());
    // setLocation(await getLocation()); 
    setBrowser(getBrowserInfo());
    };
 
    fetchUserData();    

    if (failedLoginAttempts >= 5) {
      countdownRef.current = setInterval(() => {
        const currentTime = Date.now();
        if (currentTime >= deadline) {
          clearInterval(countdownRef.current);
          setFailedLoginAttempts(0);
          setShowFailedLogin(false);
          setDeadline(0);
          localStorage.removeItem("loginData");
        }
      }, 1000);
    }

    return () => clearInterval(countdownRef.current);
  }, [failedLoginAttempts, deadline]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      setErrorEmail(false);
    } else if (name === "password") {
      setPassword(value);
      setErrorPassword(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.sessionStorage.clear();
    window.localStorage.clear();

    const emailEmpty = email.length === 0;
    const passwordEmpty = password.length === 0;

    setErrorEmail(emailEmpty);
    setErrorPassword(passwordEmpty);
    setErrorMessage("This is a required field");

    if (emailEmpty || passwordEmpty) return;


    const body = { email, password, ipAddress, browser };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, body );
      if (response.data.success && response.data.user.isAdmin) {
        openNotification("topRight", "success", "Success", "Login Successful");
        window.sessionStorage.setItem("token", response.data.token);
        // window.sessionStorage.setItem("email", email);
        setTimeout(() => navigate(`/admin/mfa`), 1000);
      } else {
        openNotification("topRight", "error", "Could not Login to your account", "Invalid email address or password");
      }
    } catch (error) {
      openNotification("topRight", "error", "Could not Login to your account", "Invalid email address or password");
      setEmail("");
      setPassword("");
      const updatedAttempts = failedLoginAttempts + 1;
      setFailedLoginAttempts(updatedAttempts);

      if (updatedAttempts >= 5) {
        const newDeadline = Date.now() + 1000 * 60 * 5;
        localStorage.setItem(
          "loginData",
          JSON.stringify({
            failedLoginAttempts: updatedAttempts,
            deadline: newDeadline,
            showFailedLogin: true,
          })
        );
        setDeadline(newDeadline);
        setShowFailedLogin(true);
      }

      console.log("error :>> ", error?.response?.data?.message);
    }
  };

  return (
    <div className="nk-app-root">
      {showFailedLogin ? (
        <FailedLogin deadline={deadline} />
      ) : (
        <div className="nk-main">
          <div className="nk-wrap nk-wrap-nosidebar">
            <div className="nk-content">
              <div className="nk-block nk-block-middle nk-auth-body wide-xs">
                <div className="brand-logo pb-4 text-center">
                  <a href={`/`} className="logo-link">
                    <img
                      className="logo-dark logo-img logo-img-lg"
                      src="/assets/images/barterfunds-logo.png"
                      alt="logo"
                    />
                  </a>
                </div>

                <div className="card card-bordered">
                  <div className="card-inner card-inner-lg">
                    <div className="nk-block-head">
                      <div className="nk-block-head-content">
                        <h4 className="nk-block-title nk-block-des">Sign-In</h4>
                        <div className="nk-block-des">
                          <p>Sign in using your email address and password.</p>
                        </div>
                      </div>
                    </div>

                    <form>
                      <TextInput
                        placeholder="Enter your email address"
                        label="Email Address"
                        inputname="email"
                        inputtype="email"
                        value={email}
                        errorState={errorEmail}
                        errorMessage={errorMessage}
                        onValueChange={handleInputChange}
                        required
                      />

                      <TextInput
                        placeholder="Enter your password"
                        label="Password"
                        inputname="password"
                        inputtype="password"
                        value={password}
                        errorState={errorPassword}
                        errorMessage={errorMessage}
                        onValueChange={handleInputChange}
                        showForgotPassword
                        showEye
                        required
                      />

                      <div className="form-group">
                        <button onClick={handleSubmit} className="btn btn-lg btn-primary btn-block">
                          Sign in
                        </button>
                      </div>
                    </form>

                    {/* <div className="form-note-s2 text-center pt-4">
                      New on our platform?
                      <a href={`/signup`}> Create an account</a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
